export default {
  hasEbook(state) {
    return state.files.length > 0;
  }
};
